<template><markdown-wrapper><h1 id="i18n">I18n <a class="header-anchor" href="#i18n">&#128279;</a></h1>
<p>All uiv components use <code v-pre>en-US</code> as default language and they are both configurable.</p>
<p><ins class="adsbygoogle"
     style="display:block; text-align:center;"
     data-ad-layout="in-article"
     data-ad-format="fluid"
     data-ad-client="ca-pub-4714899946256166"
     data-ad-slot="4603582855"></ins></p>
<h2 id="example">Example <a class="header-anchor" href="#example">&#128279;</a></h2>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">import</span> <span class="hljs-title class_">Vue</span> <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;vue&#x27;</span>
<span class="hljs-keyword">import</span> uiv <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;uiv&#x27;</span>
<span class="hljs-keyword">import</span> locale <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;uiv/src/locale/lang/zh-CN&#x27;</span>

<span class="hljs-title class_">Vue</span>.<span class="hljs-title function_">use</span>(uiv, { locale })
</code></pre>
<p>You can also create custom wordings if not satisfied with the defaults, simply create your own <code v-pre>locale</code> object and replace with the one in example code.</p>
<h2 id="with-vue-i18n">With <code v-pre>vue-i18n</code> <a class="header-anchor" href="#with-vue-i18n">&#128279;</a></h2>
<p>uiv is compatible with <a href="https://github.com/kazupon/vue-i18n">vue-i18n</a> as well.</p>
<p><strong>Note</strong>: You need to merge uiv language packs into your app's. For example:</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">import</span> uivLocale <span class="hljs-keyword">from</span> <span class="hljs-string">&#x27;uiv/src/locale/lang/zh-CN&#x27;</span>

<span class="hljs-keyword">let</span> appLocale = <span class="hljs-title class_">Object</span>.<span class="hljs-title function_">assign</span>({}, uivLocale, {
  <span class="hljs-comment">// ...</span>
})
</code></pre>
<h2 id="supported-languages">Supported languages <a class="header-anchor" href="#supported-languages">&#128279;</a></h2>
<p>(Sorted by alphabet)</p>
<ul>
<li><strong>ar-EG</strong></li>
<li><strong>bg-BG</strong></li>
<li><strong>ca-ES</strong></li>
<li><strong>cs-CZ</strong></li>
<li><strong>de-DE</strong></li>
<li><strong>en-US</strong></li>
<li><strong>es-ES</strong></li>
<li><strong>fi-FI</strong></li>
<li><strong>fr-FR</strong></li>
<li><strong>hu-HU</strong></li>
<li><strong>it-IT</strong></li>
<li><strong>ja-JP</strong></li>
<li><strong>nb-NO</strong></li>
<li><strong>nl-NL</strong></li>
<li><strong>pt-BR</strong></li>
<li><strong>ro-RO</strong></li>
<li><strong>ru-RU</strong></li>
<li><strong>sv-SE</strong></li>
<li><strong>tr-TR</strong></li>
<li><strong>zh-CN</strong></li>
</ul>
<p>Welcome to contribute if your target language is not included: just add another language config <a href="https://github.com/wxsms/uiv/blob/dev/src/locale/lang">here</a> and create a pull request.</p>
</markdown-wrapper></template><script>export default {components:{}}</script>